module.exports = __webpack_public_path__ + "img/tuzongcai.cac6398c.jpg";